// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".entity-cat[data-v-1b89e07c]{margin-bottom:.2em;margin-top:.2em}", "",{"version":3,"sources":["webpack://./resources/assets/js/partials/App/Preferences/Tags/TagsTable.vue"],"names":[],"mappings":"AAAA,6BAAA,kBAAA,CAAA,eAAA","sourcesContent":[".entity-cat{margin-top:.2em;margin-bottom:.2em}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
